
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { create } from 'vue-modal-dialogs';
    import { __, formatDate } from '@/helpers/utils';
    import TablePager from "@/components/table/Pager.vue";
    import Confirm from '@/components/confirm/Confirm.vue';
    import Spinner from "@/components/spinner/Spinner.vue";

    const confirm = create(Confirm, 'title', 'content');

    @Component({
        components: {
          Spinner,
            TablePager
        },
        props: {
            keys: Object,
            data: Array,
            links: Array,
            dates: Array,
            dateFormat: {
                type: String,
                default: () => { return 'DD.MM.YYYY'; }
            },
            pager: Object,
            customColumnClass: {
                type: Object,
                default: () => { return {}; }
            },
            excludedSorters: {
                type: Array,
                default: () => []
            },
            sortingAllowed: {
                type: Boolean,
                default: true
            },
            showSpinner: {
                type: Boolean,
                default: true
            }
        },
    })
    export default class Table extends Vue {
        private sorters: any = [];
        private activeFilter: string = '';

        public mounted() {
            this.resetFilter();
            this.activeFilter = Object.keys(this.$props.keys)[0];
        }

        @Watch('data')
        private onDataChanged(val: any, oldVal: any) {
            this.mapData();
        }

        private changePage(page: Number) {
            this.$emit('changePage', page);
        }

        private changeSort(key: any) {
            const direction = this.activeFilter === key ? !this.sorters[key] : this.sorters[key];
            this.resetFilter();
            this.sorters[key] = direction;
            this.activeFilter = key;
            this.$emit('changeOptions', {key, sort: this.sorters[key]});
        }

        private resetFilter() {
            Object.keys(this.$props.keys).forEach((key: string) => {
                this.sorters[key] = true;
            });
        }

        private createUrl(url: string, row: any) {
            return url.replace(':param:', row.id);
        }

        private mapData() {
            if (!this.$props.dates || !Array.isArray(this.$props.data)) {
                return;
            }

            this.$props.data.forEach((row: any) => {
                Object.keys(this.$props.keys).forEach((key) => {
                    if (this.$props.dates.includes(key)) {
                        row[key] = formatDate(row[key], this.$props.dateFormat);
                    } else if (typeof(row[key]) === 'boolean') {
                        if (row[key]) {
                            row[key] = 'Áno'
                        } else {
                            row[key] = 'Nie'
                        }
                    } else if (key.includes('.')) {
                        // TOTO TU JE NA TO, ABY SME VEDELI ZOBRAZOVAT HODNOTY Z VNORENYCH OBJEKTOV

                        let splitted = key.split('.');
                        let value = row;

                        splitted.forEach((s) => {
                            // check if tento objek nie je null
                            if (value) {
                                value = value[s];
                            } else {
                                value = null;
                            }
                        });

                        row[key] = value;
                    }
                });
            });
        }

        private async linkClick(link: any, row: any, event: any) {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (link.confirm === true) {
                if (await confirm('', this.translate(link.confirmMessage))) {
                    await this.$router.push(this.createUrl(link.url, row));
                }
            } else {
                await this.$router.push(this.createUrl(link.url, row));
            }
        }

        private translate(term: string) {
           return __(term);
        }
    }
